module.exports = __webpack_public_path__ + "img/2.bd7929a5.png";